import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../dataProvider/APIPaths';
import APIDataProvider from '../../dataProvider/APIDataProvider';

interface ITopicSortingItem {
  topicId: string;
  sortingOrder?: number;
}

export interface IAdminUpdateTopicSorting {
  topics: Array<ITopicSortingItem>;
}

const TopicAdminApiDataProvider = new APIDataProvider<ITopicSortingItem[]>();

export const adminUpdateTopicSorting = createAsyncThunk(
  'admin/topics/updateTopicSorting',
  async (data: IAdminUpdateTopicSorting) => {
    const response = await TopicAdminApiDataProvider.create(
      `${AdminApiPaths.topics}/updateSorting`,
      data
    );

    return response.data as IAdminUpdateTopicSorting['topics'];
  }
);

export default adminUpdateTopicSorting;
